module.exports = __webpack_public_path__ + "static/media/BeX.9132056c.jpg";